import { useContext } from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { Text } from '@shared/components/Text';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

interface Props {
  message?: string;
  isRounded?: boolean;
  marginBottom?: number;
  style?: StyleProp<ViewStyle>;
}

export function MBDefaultError({ message, isRounded = true, marginBottom = 8, style }: Props) {
  const colors = useContext(ColorThemeContext);
  const errorMessage = message ?? i18n('errors.loading');

  return (
    <MBView
      style={[
        { backgroundColor: colors.error.background },
        isRounded && styles.rounded,
        { marginBottom },
        style,
      ]}
      padding={2}
      paddingVertical={1.75}
    >
      <Text danger align="center">
        {errorMessage}
      </Text>
    </MBView>
  );
}

const styles = StyleSheet.create({
  rounded: {
    borderRadius: grid(1),
  },
});
